import { render, staticRenderFns } from "./AppHotel.vue?vue&type=template&id=937a7196&"
import script from "./AppHotel.vue?vue&type=script&lang=js&"
export * from "./AppHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports